import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { getOrderEditsURL, postOrderUpdatesURL } from "../utils/api";
import {
    Box,
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    Input,
    Switch,
    Text,
    Select,
    Progress,
    Table,
    Thead,
    Tbody,
    Th,
    Tr,
    Td,
    useColorModeValue
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "assets/css/easychek.css";

import useGetServices from "../hooks/useGetServices";
import CustomizeService from "../views/Custom/CustomizeService";
import EstimateService from "../views/Custom/EstimateService";
import EstimateMechanic from "../views/Custom/EstimateMechanic";
import useGetOrderEdit from "../hooks/useGetOrderEdit";


function EditOrder({
    isOpen,
    onClose,
    orderData,
    successCallback
}) {
    const textColor = useColorModeValue("gray.700", "white");   

    if (orderData == null) {
        return (<></>);
    }
    
    const { auth } = useAuth();
    // const [ newOrderData, setNewOrderData ] = useState(null);
    const [ carMake, setCarMake ] = useState('');
    const [ carType, setCarType ] = useState('');
    const [ carYear, setCarYear ] = useState('');
    const [ carPlate, setCarPlate ] = useState('');
    const [ carOdometer, setCarOdometer ] = useState('');
    const [ orderServices, setOrderServices ] = useState([]);
    const [ orderMechanics, setOrderMechanics ] = useState([]);
    const [ receiveDate, setReceiveDate ] = useState(null);
    const [ warrantyEnd, setWarrantyEnd ] = useState(null);
    const [ discount, setDiscount ] = useState('0');
    const [ laborTotal, setLaborTotal ] = useState(0);
    const [ partsTotal, setPartsTotal ] = useState(0);


    const [ invDiscount, setInvDiscount ] = useState(null);

    const {
        orderEdit, 
        gettingOrderEdit, 
        setGettingOrderEdit, 
        gettingOrderEditReqSuccess
    } = useGetOrderEdit({ orderId: orderData.id });
  
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);
    const [ successMsg, setSuccessMsg ] = useState(null);


    const postOrderUpdate = (e) => {
        e.preventDefault();


        let id;
        if (orderData) {
            id = orderData.id;
        }
        setSubmitting(true);
        setErrors([]);
        setSuccessMsg(null);

        // console.log(stock, price);
        axios.post(postOrderUpdatesURL(id), {
            carMake: carMake,
            carType: carType,
            carYear: carYear,
            carPlate: carPlate,
            carOdometer: carOdometer,
            receiveDate: receiveDate.toISOString(),
            warrantyEnd: warrantyEnd.toISOString(),
            services: orderServices,
            mechanics: orderMechanics, 
            discount: discount, 
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200 || result.status === 201) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                if (successCallback) {
                    successCallback();
                }
                // setOrderServices([]);
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }


    useEffect(() => {
        if (orderData && isOpen) {
            // console.log(orderData);
            // // setUpdatedOrderData(orderData);
            setGettingOrderEdit(true);
            setErrors([]);
        }

        if (!isOpen) {
            setCarMake(null);
            setCarType(null);
            setCarYear(null);
            setCarPlate(null);
            setCarOdometer(null);
            setOrderServices([]);
            setOrderMechanics([]);
            setReceiveDate(null);
            setWarrantyEnd(null);
            setDiscount('0');
        }

    }, [orderData, isOpen]);

    useEffect(() => {
        if (orderEdit) {
            // console.log(orderEdit.orderMechanics);
            setCarMake(orderEdit.carMake);
            setCarType(orderEdit.carType);
            setCarYear(orderEdit.carYear);
            setCarPlate(orderEdit.carPlate);
            setCarOdometer(orderEdit.carOdometer);
            setOrderServices(orderEdit.orderServices ?? []);
            setOrderMechanics(orderEdit.orderMechanics ?? []);
            setReceiveDate(orderEdit.receiveDate ? new Date(orderEdit.receiveDate) : null);
            setWarrantyEnd(orderEdit.warrantyEnd ? new Date(orderEdit.warrantyEnd) : null);
            setDiscount(orderEdit.discount ?? '0');
            // setNewOrderData(orderEdit);
        }
    }, [orderEdit]);


    useEffect(() => {
        setErrors([]);

        const tmpErrors = [];
        if (!carMake || carMake.trim() == "") tmpErrors.push('Car Make is required');
        if (!carType || carType.trim() == "") tmpErrors.push('Car Type is required');
        if (!carYear || carYear.trim() == "") tmpErrors.push('Car Year is required');
        if (!carPlate || carPlate.trim() == "") tmpErrors.push('Car Plate is required');
        if (!carOdometer || carOdometer.trim() == "") tmpErrors.push('Car Odometer is required');
        if (!discount || discount.trim() == "" || !validator.isInt(discount) || parseInt(discount) < 0) tmpErrors.push('Invalid discount');

        if (orderServices.length == 0) {
            tmpErrors.push("Add atleast 1 service");
        } 

        let lTotal = 0;
        let pTotal = 0;
        if (orderServices.length > 0) {
            orderServices.forEach((os, osIndex) => {
                // console.log(parseFloat(os.price));
                lTotal += parseFloat(os.price);
                // console.log(laborTotal);
                if (os.addedProducts.length > 0) {
                    os.addedProducts.forEach((p) => {
                        p.addedStocks.forEach((s) => {
                            pTotal += (parseFloat(s.quantity) * parseFloat(s.price));
                        });
                    });
                    // console.log(partsTotal);
                }
            });
        } else {
            tmpErrors.push("Add atleast 1 service");
        }
        
        setLaborTotal(lTotal);
        setPartsTotal(pTotal);
        
        if (isNaN(lTotal + pTotal)) {
            tmpErrors.push("Invalid pricing, Pls check service item's quantity or price");
        }

        if ((lTotal+pTotal)-parseFloat(discount) < 0) {
            tmpErrors.push("Invalid pricing, Pls check service item's quantity or price");
        }

        setErrors(tmpErrors);
    }, [discount, carMake, carType, carYear, carPlate, carOdometer, orderMechanics, orderServices]);




    const onAddedServiceUpdate = (service) => {
        // console.log('test');
        // console.log(service);
        const tmp = [...orderServices];
        tmp.forEach((s, index) => {
            if (s.id == service.id) {
                tmp[index] = service;
            }
        });
        setOrderServices(tmp);
        // console.log(service);
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="xxl">
            <ModalOverlay />
            <ModalContent mx={12}>
                <ModalHeader>Update Order</ModalHeader>
                <ModalCloseButton />
                <ModalBody overflow={"auto"}>
                    {  orderData && gettingOrderEdit 
                        ? <Progress isIndeterminate />
                        : <form onSubmit={postOrderUpdate}>
                            <Flex 
                                flexDirection="row" 
                                pt={{ base: "120px", md: "0px" }}
                                overflow={"auto"}>
    
    
    
                                <Flex 
                                    flexDirection="column" 
                                    flexBasis={"66.66%"}
                                    m={2}
                                    >
    
                                    {/* ORder DEtails */}
                                    <Flex flexDirection="column" w="100%">
                                        <Text fontSize="sm" color="black.400" fontWeight="bold" mb={4}>
                                            Customer: {orderData.customer.companyName 
                                                ? orderData.customer.companyName
                                                : `${orderData.customer.firstName} ${orderData.customer.lastName}`
                                            }
                                        </Text>
                                    </Flex>
    
    
                                                            
                                    <Card p="1.2rem">
                                        <CardBody
                                            p="0px"
                                            w="100%"
                                            h={{ sm: "auto", lg: "auto" }}
                                            position="relative"
                                            borderRadius="15px"
                                        >
    
                                            {/* Car DEtails */}
                                            <FormControl marginBottom="12px">
                                                <Text fontSize="sm" color="gray.400" fontWeight="bold" mb={4}>
                                                    VEHICLE DETAILS
                                                </Text>
                                                <Flex flexDirection="row" w="100%">
                                                    <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                                                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                                            Make
                                                        </FormLabel>
                                                        <Input
                                                            borderRadius="15px"
                                                            mb="12px"
                                                            fontSize="sm"
                                                            type="text"
                                                            placeholder="Toyota"
                                                            size="md" 
                                                            isRequired={true}
                                                            value={carMake} 
                                                            onChange={e => setCarMake(e.target.value)}
                                                        />
                                                    </Box>
    
                                                    <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                                                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                                            Type
                                                        </FormLabel>
                                                        <Input
                                                            borderRadius="15px"
                                                            mb="12px"
                                                            fontSize="sm"
                                                            type="text"
                                                            placeholder="Camry"
                                                            size="md" 
                                                            isRequired={true}
                                                            value={carType} 
                                                            onChange={e => setCarType(e.target.value)}
                                                        />
                                                    </Box>
    
                                                    <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                                                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                                            Year
                                                        </FormLabel>
                                                        <Input
                                                            borderRadius="15px"
                                                            mb="12px"
                                                            fontSize="sm"
                                                            type="number"
                                                            placeholder="2020"
                                                            size="md" 
                                                            isRequired={true}
                                                            value={carYear} 
                                                            onChange={e => setCarYear(e.target.value)}
                                                        />
                                                    </Box>
                                                </Flex>
    
                                                <Flex flexDirection="row" w="100%">
    
                                                    
                                                    <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                                                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                                            Plate #
                                                        </FormLabel>
                                                        <Input
                                                            borderRadius="15px"
                                                            mb="12px"
                                                            fontSize="sm"
                                                            type="text"
                                                            placeholder="1234-ABCD"
                                                            size="md" 
                                                            isRequired={true}
                                                            value={carPlate} 
                                                            onChange={e => setCarPlate(e.target.value)}
                                                        />
                                                    </Box>
    
                                                    <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                                                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                                            Odometer
                                                        </FormLabel>
                                                        <Input
                                                            borderRadius="15px"
                                                            mb="12px"
                                                            fontSize="sm"
                                                            type="number"
                                                            placeholder="5000"
                                                            size="md" 
                                                            isRequired={true}
                                                            value={carOdometer} 
                                                            onChange={e => setCarOdometer(e.target.value)}
                                                        />
                                                    </Box>
    
                                                </Flex>
                                            </FormControl>
    
                                        </CardBody>
                                    </Card>
    
                                    <Card p="1.2rem" mt={4}>
                                        <CardBody
                                            p="0px"
                                            w="100%"
                                            h={{ sm: "auto", lg: "auto" }}
                                            position="relative"
                                            borderRadius="15px"
                                        >
                                            <Flex flexDirection="column" w="100%">
                                            <Text fontSize="sm" color="gray.400" fontWeight="bold">
                                                ADDED SERVICES { orderServices.length > 0 ? `(${orderServices.length})` : "(None)"}
                                            </Text>
                                            
                                            { orderServices.map((service, sIndex) => {
                                                    // console.log(service);
                                                    return <Flex direction="column" w="100%" key={`service-toggle-${sIndex}`}>
                                                        <CustomizeService 
                                                            serviceData={service}
                                                            onDataUpdated={onAddedServiceUpdate}
                                                        />
                                                    </Flex>
                                                })
                                            }
    
                                            </Flex>
    
                                        </CardBody>
                                    </Card>
    
                                 
                                    <Flex flexDirection="column" w="100%">

                
                                        <Flex flexDirection="row" w="100%">
                                            {/* Receive Date */}
                                            <FormControl ml="24px" marginBottom="12px">
                                                <Flex flexDirection="column" w="100%">
                                                    <FormLabel>Receive Date</FormLabel>
                                                    <DatePicker 
                                                        className="easychek-date-picker"
                                                        selected={receiveDate} onChange={(date) => setReceiveDate(date)} />
                                                </Flex>
                                            </FormControl>


                                            {/* WArranty Date */}
                                            <FormControl ml="24px" marginBottom="12px">
                                                <Flex flexDirection="column" w="100%">
                                                    <FormLabel>Warranty Date</FormLabel>
                                                    <DatePicker 
                                                        className="easychek-date-picker"
                                                        selected={warrantyEnd} onChange={(date) => setWarrantyEnd(date)} />
                                                </Flex>
                                            </FormControl>

                                        </Flex>


                                        <FormControl paddingX="24px" marginBottom="12px">
                                            <FormLabel mt="12px" ms="4px" fontSize="sm" fontWeight="normal">
                                                Discount
                                            </FormLabel>
                                            <Input
                                                borderRadius="15px"
                                                mb="12px"
                                                fontSize="sm"
                                                type="text"
                                                placeholder="0.0"
                                                size="md" 
                                                isInvalid={invDiscount === true}
                                                isRequired={true}
                                                value={discount} 
                                                onChange={e => setDiscount(e.target.value)}
                                            />
                                        </FormControl>

                                        <Text fontSize="sm" fontWeight="bold" width="100%" mt={4}>
                                            To enable fill up all inputs
                                        </Text>

                                        <Flex w="100%" flexDir="column">
                                            <Text fontSize="sm" fontWeight="bold" width="100%" mt={4}>
                                                Subotal: {partsTotal + laborTotal}
                                            </Text>

                                            <Text fontSize="sm" fontWeight="bold" width="100%">
                                                Total: {(partsTotal + laborTotal) - parseFloat(discount)}
                                            </Text>
                                        </Flex>

                                        <Flex w="100%" flexDir="column">
                                            { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                                        </Flex>
    
                                        <Flex flexDirection="row" w="100%">
                                            
                                            <Button
                                                fontSize="10px"
                                                type="button"
                                                bg="blue.300"
                                                w="33%"
                                                h="45"
                                                m="12px"
                                                color="white"
                                                _hover={{
                                                bg: "blue.200",
                                                }}
                                                _active={{
                                                bg: "blue.400",
                                                }}
                                                tool
                                                disabled={orderData == null 
                                                    || errors.length > 0
                                                    || submitting 
                                                }
                                                onClick={orderData == null 
                                                        || errors.length > 0
                                                        || submitting
                                                    ? null 
                                                    : (e) => postOrderUpdate(e)
                                                }
                                            >
                                                SUBMIT
                                            </Button>
                                        </Flex>
                                    </Flex>
    
                                </Flex>
    
                                <Flex 
                                    flexDirection="column" 
                                    flexBasis={"33.33%"}
                                    m={2}
                                    >
                                    <Card p="1.2rem">
                                        <CardBody
                                            p="0px"
                                            w="100%"
                                            h={{ sm: "auto", lg: "auto" }}
                                            position="relative"
                                            borderRadius="15px" 
                                        >
    
                                            <EstimateMechanic 
                                                orderMechanics={orderMechanics}
                                                setOrderMechanics={setOrderMechanics} 
                                            />
    
                                        </CardBody>
                                    </Card>
    
                                    <EstimateService 
                                        orderServices={orderServices} 
                                        setOrderServices={setOrderServices}
                                    />
    
                                </Flex>
                            
                            
                            </Flex>
                        </form>
                    }


                </ModalBody>
            </ModalContent>
        </Modal>
    );

}



export default EditOrder;
